import { media } from '../gatsby-plugin-theme-ui/breakpoints';

const styles = {
  Container: {
    p: 4,
    maxWidth: 1280,
  },
  root: {
    fontSize: 1,
    lineHeight: 'body',
    color: 'text',
    bg: 'background',
    fontFamily: 'Inter, system-ui, sans-serif',
  },
  a: {
    color: 'primary',
    textDecoration: 'underline',
    '&:hover': {
      color: 'secondary',
      textDecoration: 'underline',
    },
  },
  p: {
    color: 'text',
    mt: 2,
    mb: 4,
    'h1 > &': {
      fontWeight: 'medium',
      fontSize: 3
    },
    ':last-child': {
      mb: 0
    }
  },
  h1: {
    fontSize: 5,
    lineHeight: 'heading',
    fontWeight: 'heading',
    mt: 0,
    mb: 5
  },
  h2: {
    fontSize: 3,
    lineHeight: 'heading',
    fontWeight: 'heading',
    mt: 7,
    mb: 4
  },
  h3: {
    fontSize: 2,
    fontWeight: 'heading',
    lineHeight: 'heading',
    letterSpacing: 'caps',
    textTransform: 'uppercase',
    mt: 6,
    mb: 2
  },
  h4: {
    fontSize: 2,
    lineHeight: 'heading',
    fontWeight: 'heading',
    my: 3
  },
  h5: {
    fontSize: 2,
    fontWeight: 'heading',
  },
  h6: {
    fontSize: 1,
    fontWeight: 'heading',
  },
  ul: {
    p: 0,
    pl: 2,
    ml: 3,
    mb: 3,
    listStyle: 'outside circle',
    ':last-child': {
      mb: 0
    }
  },
  ol: {
    p: 0,
    pl: 2,
    ml: 3,
    mb: 3,
    listStyle: 'outside decimal',
    ':last-child': {
      mb: 0
    }
  },
  li: {
    my: 2,
    pl: 0,
  },
  blockquote: {
    my: 4,
    mx: 0,
    py: 3,
    px: 4,
    bg: 'blockquote.bg',
    color: 'blockquote.color',
    fontStyle: 'italic',
    '> p': {
      m: 0,
    },
  },
  code: {
      fontFamily: 'monospace',
    textWrap: 'wrap'
  },
  inlineCode: {
    fontFamily: 'monospace',
  },
  pre: {
    m: 0,
    mt: 2,
    mb: 4,
    p: 0,
    variant: 'prism',
    textAlign: 'left',
    fontFamily: 'monospace',
    'pre': {
      m: 0
    },
    [media.tablet]: {
      p: 0
    }
  },
  table: {
    width: '100%',
    my: 4,
    fontSize: 0,
    borderCollapse: 'separate',
    borderSpacing: 0,
    [['th', 'td']]: {
      textAlign: 'left',
      py: 2,
      pr: 3,
      pl: 0,
      maxWidth: '50%'
    },
  },
  tr: {
    '&:first-of-type td': {
      pt: 3
    },
  },
  th: {
    verticalAlign: 'bottom',
    borderBottom: '1px solid',
    borderColor: 'border',
    fontSize: 1,
    fontWeight: 'body',
    color: 'muted'
  },
  td: {
    verticalAlign: 'top',
    borderBottomWidth: '1px',
    '&:first-of-type': {
      fontWeight: 'medium',
      minWidth: '12em'
    }
  },
  hr: {
    border: 0,
    borderBottom: t => `1px solid ${t.colors.border}`,
  },
  img: {
    'max-width': '100%',
  }
}

export default styles
